import { useMemo } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './SgPoliciesSummary.metadata.json5';

import SgPolicySummaryTile from './sg-policy-summary-tile/SgPolicySummaryTile';

function SgPoliciesSummary(props) {
    const {
        policies
    } = props;

    const generateOverrides = useMemo(() => {
        const overrides = policies.map((item, index) => {
            return {
                [`cepPolicyTile${index}`]: {
                    policy: item
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [policies]);

    const overrides = {
        cepPoliciesSummaryTiles: {
            data: policies
        },
        sgPoliciesSummaryHeader: {
            visible: policies.length ? '' : false
        },
        ...generateOverrides
    };
    const resolvers = {
        resolveComponentMap: {
            SgPolicySummaryTile: SgPolicySummaryTile
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgPoliciesSummary;
